import {map} from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class PdfGeneratorService {
    public static readonly BaseUrl = "api/reports";

    constructor(public http: HttpClient) {

    }

    generate(id: string, questionKey: string): Observable<Uint8Array> {
        const options: {
            headers?: HttpHeaders | {
                          [header: string]: string | string[];
                      };
            observe?: "body";
            params?: HttpParams | {
                         [param: string]: string | string[];
                     };
            reportProgress?: boolean;
            responseType: "arraybuffer";
            withCredentials?: boolean;
        } = { responseType: "arraybuffer" };
        return this.http.get(`${PdfGeneratorService.BaseUrl}/${id}/${questionKey}`, options).pipe(
            map((arrayBuffer: ArrayBuffer) => new Uint8Array(arrayBuffer)));
    }
}
